import { render, staticRenderFns } from "./CoordPicker.vue?vue&type=template&id=f5887d26&scoped=true"
import script from "./CoordPicker.vue?vue&type=script&lang=js"
export * from "./CoordPicker.vue?vue&type=script&lang=js"
import style0 from "./CoordPicker.vue?vue&type=style&index=0&id=f5887d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5887d26",
  null
  
)

export default component.exports